import React, {Component} from 'react'
import ReactTable from "react-table";
import * as config from '../Configuration/Config.js'
import UserProfile from '../Configuration/UserProfile.js'
import Collapsible from 'react-collapsible';

class CustomWorkspace extends Component {
    constructor() {
        super();         
        
        this.state = {
            is_loaded: false,
            customer: null,
            userprofile: null,
            vizzes: null,
            datasets: null,
            user: null,
            folders: null
        }
    }

    componentDidMount() {       
       
        this.profile = new UserProfile();        
        var varCustomerId = this.profile.CustomerId();
        var varUserId = this.profile.UserId();
        
        //customerinfo
        var that = this;        
        const uri = config.getUriPath('customers/' + varCustomerId)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }
            return response.json();
          })
          .then(function(data) {
            //that.setState({ userprofile: that.profile, customer: data });
            that.fetchVizzes(that.profile,data);
            console.log(data);            
          });

          //console.log('customer_custom_workspace_id : ' + this.state.customer_custom_workspace_id);
    }

    fetchVizzes(userprofile, customer)
    {
        var that = this;
        const uri = config.getUriPath('customers/viewscw/' + customer.customer_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
        })
        .then(function(data) { 
                that.fetchdatasets(userprofile,customer,data);                                                                         
        });
      
    }

    fetchdatasets(userprofile, customer, vizzes)
    {
        var that = this;
        const uri = config.getUriPath('customers/getdatasetscw/' + customer.customer_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
        })
        .then(function(data) {                                                           
                that.fetchuser(userprofile, customer, vizzes, data);
        });
      
    }    

    fetchuser(userprofile, customer, vizzes, datasets)
    {
        this.profile = new UserProfile();                
        var varUserId = this.profile.UserId();
        console.log('varUserId: ' + varUserId);
        var that = this;
        const uri = config.getUriPath('users/profile/' + varUserId)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
        })
        .then(function(data) {                                                           
                that.fetchfolder(userprofile, customer, vizzes, datasets, data);
        });
    }    

    fetchfolder(userprofile, customer, vizzes, datasets,user)
    {
        var that = this;        
        //let uri = config.getAcumenAPIURL('customer/' + customer.customer_id + '/foldersmenu');        
        let uri = config.getAcumenAPIURL('api/user/foldersmenu/' + user.user_id);
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix()); 
        fetch(uri, {
            method: 'get',
            headers: myHeaders
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {
            console.log('folders loaded')
            that.setState({ is_loaded: true,userprofile: userprofile, customer: customer, vizzes:vizzes, datasets: datasets, user:user, folders: data.folders});            
        });
    }

    handleDelete(reportid,groupid) {
        const canDel = window.confirm('Are you sure you want to delete this report?');
        
        if (canDel === false) {
            return;
        }
        
        const customer = this.state.customer;
        var that = this;                
        let cleanupuri = config.getAcumenAPIURL('customer/' + customer.customer_id + '/foldercleanup/' + reportid);     
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix());
        fetch(cleanupuri, {
            method: 'get',
            headers: myHeaders
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {
            console.log('foldercleanup') 
            const uri = config.getUriPath('visualizations/deleteReport?id=' + reportid + '&group_id=' + groupid);
            fetch(uri, {
                method: 'delete',
                headers: config.ApiHeaders()
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                window.location.reload();          
            });           
        });

        
        
    }

    render() {  
        const customer = this.state.customer;
        const vizzes = this.state.vizzes;
        const datasets = this.state.datasets;        
        const user = this.state.user;
        const folders = this.state.folders;
        var show_custom_workspace = 0;
        var full = false;
        var edit = false;
        var view = false;

        if (this.state.is_loaded === false) {return <div className="grid-wrapper"><div className="center-div"><h1>myAcumen</h1></div></div> }

        if (customer === null || vizzes === null || datasets===null || user===null) {
             return <div className="grid-wrapper">
                    <div className="center-div">
                        <h1>myAcumen</h1>                        
                    </div>
                </div> 
        }       

        if(user !== null)
        {
            //show_custom_workspace                           
            show_custom_workspace = user.show_custom_workspace;
            console.log(show_custom_workspace);
            console.log('customer_custom_workspace_id : ' + customer.customer_custom_workspace_id);

            if (show_custom_workspace == 0)
            {
                //no access
                full = false;
                edit = false;
                view = false;
            }

            if (show_custom_workspace == 1)
            {
                //full
                full = true;
                edit = true;
                view = true;
            }

            if (show_custom_workspace == 2)
            {
                //edit and view
                full = false;
                edit = true;
                view = true;
            }

            if (show_custom_workspace == 3)
            {
                //view
                full = false;
                edit = false;
                view = true;
            }

        }

        return <div className="grid-wrapper">
                    <div className="center-div">
                        <h1>myAcumen</h1>                        
                    </div>

                   

                    <div className="container-fluid">


                    <div className="row">
                    <div className="col">&nbsp;</div>
                    <div className="col-6">
                    <div className="row mb-3"> 
                    <div className="myReports">                       
                        <div className="myReportsTitle">
                            My Reports
                            <div className={full ? "foldersadd" : "hidden"}>
                                <a href={"/cw/folders/" + customer.customer_id + "/new" } title="Add New Folder"><i className="fas fa-folder-plus foldersaddstyle"></i></a>
                            </div>
                        </div>
                        {
                            folders.map((folder) => (
                                <div className="myReportsCell">                                
                                <div className={folder.folder_name !== 'Public' ? "foldersedit" : "hidden"}>
                                    <div className={full ? "show" : "hidden"}>
                                        <a href={"/cw/folders/" + customer.customer_id + "/" + folder.id  } title="Folder Settings"><i className="fas fa-cog folderseditstyle"></i></a>
                                    </div>
                                </div>   
                                <Collapsible trigger={folder.folder_name}>
                                                                  
                                <div className="ReactTable cwreacttable">
                                    <div className="rt-table" role="grid">                                    
                                        <div className="rt-tbody" tyle={{'min-width': '100px'}}>
                                            {
                                                folder.visualizations.map((visuals) => {
                                                return (
                                                    <div className="rt-tr-group" role="rowgroup">
                                                        <div className="rt-tr -odd" role="row">
                                                            <div className="rt-td" role="gridcell" style={{flex: '100 0 auto', width: '100px'}}>
                                                                <div className="row mb-3 cwrow">
                                                                    <div className="col-md-6 cwtitle">
                                                                        {visuals.title}
                                                                           
                                                                    </div>
                                                                    <div className="col-md-6 cwbtncol">
                                                                        <div class="row2 float-right">
                                                                            <div className="cwbtndiv">
                                                                                <a href={visuals.url.replace('/edit/','/view/')} className={view ? "btn btn-info cwview" : "hidden"} role="button">VIEW</a>
                                                                            </div>
                                                                            <div className="cwbtndiv">
                                                                                <a href={visuals.url} className={edit ? "btn btn-success cwedit" : "hidden"} role="button">EDIT</a>
                                                                            </div>
                                                                            <div className="cwbtndiv">                                              
                                                                                <div className={full ? "btn btn-warning cwdelete" : "hidden"} role="button" onClick={() => this.handleDelete(visuals.rid,visuals.gid)}>
                                                                                    DELETE
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                    <br></br>
                                </div>
                                </Collapsible>
                                </div>
                                ))
                        }    
                    </div>
                    </div>
                    </div>
                    <div className="col">&nbsp;</div>
                    </div>



           
                    </div>   

                    <br />
                    <br />
                    
                    <div className={full ? "container-fluid" : "hidden"}>
                    <div className="row">
                    <div className="col">&nbsp;</div>
                    <div className="col-6">
                    <div className="row mb-3 cwrow">
                    <ReactTable
                        data={datasets}
                        minRows="0"
                        className="cwreacttable"
                        columns={[
                            {
                                Header: "Build a Report",                                
                                accessor: "title",
                                Cell: row=>(
                                   
                                    <div className="row mb-3 cwrow">
                                                            <div className="col-md-6 cwtitle">{row.original.title}</div>
				                                            <div className="col-md-6 cwbtncol">
                                                            <div className="row2 float-right">      
                                                                <div className="cwbtndiv">
                                                                    <a href={row.original.url} className="btn btn-info cwcreate" role="button">CREATE</a>
                                                                </div>   
                                                                <div className="cwbtndiv"></div>
                                                                <div className="cwbtndiv"></div>                                                                                                                           
				                                            </div>
                                                        </div>
                                                        </div>
                                )
                            }
                        ]}
                        defaultSorted={[
                            {
                                id: "title",
                                desc: false
                            }
                        ]}
                        defaultPageSize={vizzes.length}
                        showPagination={false}
                         >
                    </ReactTable>
                    
                    </div>
                    </div>
                    <div className="col">&nbsp;</div>
                    </div>
                    </div>
                    
                 <br></br><br></br>
                </div>;              
    }
}

export default CustomWorkspace


// WEBPACK FOOTER //
// ./src/Components/CW/cw.js